import Vue from 'vue'
import VueRouter from 'vue-router'
import map from './map'
import config from './config'

Vue.use(VueRouter)

export function createRouter() {
    const router = new VueRouter({
        mode: 'hash',
        routes: map
    })
    config(router)
    return router
}